import React from 'react';

const Experience = () => {
  const experiences = [
    {
      date: 'Nov 2024 - Dec 2025',
      title: 'Graduate Research Assistant',
      company: 'Texas State University — San Marcos, TX',
      details: [
        'Researching and implementing Retrieval-Augmented Generation (RAG) pipelines and document parsing techniques for automated code analysis and generation using Node.js, JavaScript, and Python.',
        'Working with GenAI models and advanced prompting strategies to explore automated code generation from requirements and specifications, with focus on contract validation and code quality.',
        'Investigating runtime contract validation methodologies and automated testing approaches, studying Design by Contract Methodologies, and their impact on debugging efficiency and code reliability.'
      ]
    },
    {
      date: 'Jan 2023 - Jul 2023',
      title: 'Software Developer Intern',
      company: 'National Informatics Centre — Hyderabad, India',
      details: [
        'Developed and deployed a secure full-stack bank payment application using JavaScript, Node.js, React.js, and PostgreSQL, enabling 100+ users in pilot testing to create accounts, transfer funds, and track transactions in real time.',
        'Improved backend query performance by 30% through optimized database design and indexing in PostgreSQL, reducing average transaction response times from 1.5s to 1.0s.',
        'Built and integrated RESTful APIs with Express.js and ensured secure authentication/authorization, enhancing application security and reliability.'
      ]
    }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h2 className="section-title">Experience</h2>
        <div className="experience-timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="experience-item">
              <div className="experience-date">{exp.date}</div>
              <div className="experience-content">
                <h3 className="experience-title">{exp.title}</h3>
                <h4 className="experience-company">{exp.company}</h4>
                <ul className="experience-details">
                  {exp.details.map((detail, idx) => (
                    <li key={idx}>{detail}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;

